class ProductAddons {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupEventListeners());
    } else {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    // Find the main product form
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    // Override the form submission to handle addons
    productForm.addEventListener('submit', (e) => this.handleFormSubmit(e));
  }

  handleFormSubmit(event) {
    event.preventDefault();
    
    const form = event.target;
    const formData = new FormData(form);
    
    // Get main product data
    const mainProductVariantId = formData.get('id');
    const quantity = parseInt(formData.get('quantity') || '1');
    
    if (!mainProductVariantId) {
      console.error('No main product variant ID found');
      return;
    }

    // Collect selected addons
    const selectedAddons = this.getSelectedAddons();
    
    // Generate a unique group ID for this purchase
    const groupId = 'group_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    
    // Prepare items for cart
    const cartItems = [
      {
        id: mainProductVariantId,
        quantity: quantity,
        properties: {
          '_addon_group': groupId,
          '_is_main_product': 'true'
        }
      }
    ];

    // Add selected addons with group relationship
    selectedAddons.forEach(addon => {
      cartItems.push({
        id: addon.variantId,
        quantity: 1,
        properties: {
          '_addon_group': groupId,
          '_addon_for': mainProductVariantId
        }
      });
    });

    // Add items to cart
    this.addItemsToCart(cartItems, form);
  }

  getSelectedAddons() {
    const addons = [];
    const checkboxes = document.querySelectorAll('.product-addons__checkbox:checked');
    
    checkboxes.forEach(checkbox => {
      const variantId = checkbox.dataset.variantId;
      const price = checkbox.dataset.price;
      const title = checkbox.dataset.title;
      
      if (variantId) {
        addons.push({
          variantId: variantId,
          price: price,
          title: title
        });
      }
    });

    return addons;
  }

  async addItemsToCart(items, form) {
    try {
      // Show loading state
      const submitButton = form.querySelector('[type="submit"]');
      const originalText = submitButton.textContent;
      submitButton.textContent = 'Adding to Cart...';
      submitButton.disabled = true;

      // Add items to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Items added to cart:', result);

      // Trigger cart update events
      this.triggerCartUpdate();
      
      // Show success feedback
      this.showSuccess(items.length);

    } catch (error) {
      console.error('Error adding items to cart:', error);
      this.showError();
    } finally {
      // Restore button state
      const submitButton = form.querySelector('[type="submit"]');
      submitButton.textContent = originalText;
      submitButton.disabled = false;
    }
  }

  triggerCartUpdate() {
    // Trigger cart drawer update if it exists
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    
    // Update cart count
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update cart count in header if element exists
        const cartCount = document.querySelector('[data-cart-count]');
        if (cartCount) {
          cartCount.textContent = cart.item_count;
        }
      })
      .catch(error => console.error('Error updating cart count:', error));
  }

  showSuccess(itemCount) {
    // Create success message
    const message = itemCount > 1 
      ? `${itemCount} items added to cart!` 
      : 'Item added to cart!';
    
    this.showNotification(message, 'success');
  }

  showError() {
    this.showNotification('Error adding items to cart. Please try again.', 'error');
  }

  showNotification(message, type) {
    // Create notification element
    const notification = document.createElement('div');
    notification.className = `product-addons-notification product-addons-notification--${type}`;
    notification.textContent = message;
    
    // Style the notification
    Object.assign(notification.style, {
      position: 'fixed',
      top: '20px',
      right: '20px',
      padding: '15px 20px',
      backgroundColor: type === 'success' ? '#4caf50' : '#f44336',
      color: 'white',
      borderRadius: '4px',
      zIndex: '10000',
      fontSize: '14px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
    });

    // Add to page
    document.body.appendChild(notification);

    // Remove after 3 seconds
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    }, 3000);
  }
}

// Initialize when script loads
new ProductAddons(); 